import { TransactionModel } from "@interfaces/index";
import { TABLE_TRANSACTIONS_COLUMNS } from "@utils/index";
import {
  Table,
  TableHead,
  TableBody,
  TrNoItems,
  TableRowTransaction,
  Pagination,
  PerPage,
} from "@components/index";

export const TabTransactions = ({
  transactions,
  countTransactions,
  disabledFeatures,
  isMobile,
  selectedPage,
  perPage,
  onSelectPage,
  onSelectPerPage,
  onDetails,
  onRemove,
}: {
  transactions?: TransactionModel[];
  countTransactions: number;
  disabledFeatures: string[];
  isMobile: boolean;
  selectedPage: number;
  perPage: string;
  onSelectPage: (page: number) => void;
  onSelectPerPage: (value: string) => void;
  onDetails: (uniqueId: string) => void;
  onRemove: (uniqueId: string) => void;
}) => (
  <>
    <Table
      className="pb-4 pt-4 md:pb-0 md:pt-6"
      dataTestid="table_submissionDetailsTable"
    >
      {!isMobile && (
        <TableHead
          columns={TABLE_TRANSACTIONS_COLUMNS.filter(
            ({ title }) =>
              title !== "Asset" || !disabledFeatures.includes("Assets"),
          )}
          dataTestid="thead_submissionDetailsTable"
        />
      )}
      <TableBody dataTestid="tbody_submissionDetailsTable">
        {transactions?.length ? (
          transactions.map((transaction) => (
            <TableRowTransaction
              key={transaction.uniqueId}
              transaction={transaction}
              hideAssetColumn={disabledFeatures.includes("Assets")}
              onDetails={() => onDetails(transaction.uniqueId)}
              onRemove={() => onRemove(transaction.uniqueId)}
            />
          ))
        ) : (
          <TrNoItems title="No transactions found" />
        )}
      </TableBody>
    </Table>
    {countTransactions > 0 && (
      <div className="flex flex-col gap-y-6 md:flex-row md:gap-x-6">
        <Pagination
          count={countTransactions}
          perPage={parseInt(perPage, 10)}
          currentPage={selectedPage}
          onSelect={onSelectPage}
        />
        <PerPage perPage={perPage} onSelect={onSelectPerPage} />
      </div>
    )}
  </>
);
